import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-accordion-panel-header',
  template: `<ng-content></ng-content>
`,
  styles: [``]
})
export class AccordionPanelHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
